module.exports = __webpack_public_path__ + "media/video_1.cfcfef2c.mp4";